/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Dashboard_Menu_TitleInputs */

const en_company_dashboard_menu_title = /** @type {(inputs: Company_Dashboard_Menu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const de_company_dashboard_menu_title = /** @type {(inputs: Company_Dashboard_Menu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menü`)
};

/**
* | output |
* | --- |
* | "Menu" |
*
* @param {Company_Dashboard_Menu_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_dashboard_menu_title = /** @type {((inputs?: Company_Dashboard_Menu_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Dashboard_Menu_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_dashboard_menu_title(inputs)
	return en_company_dashboard_menu_title(inputs)
});